import {useOrderViewStore} from '../../store/pinia/orderview.store';
import Vue, {computed} from 'vue';
import {Store} from 'vuex';
import {STEPS} from '../../services/const.enum';
import {UNTOUCHED} from '../../store/const';

export const setupPaymentMethod = (store: Store<any>) => {
  const orderViewStore = useOrderViewStore();
  Vue.component('PaymentMethod', () => import('./components/PaymentMethod.vue'));
  orderViewStore.addCard({
    name: STEPS.PAYMENT_METHOD,
    step: () => STEPS.PAYMENT_METHOD,
    isShown: computed(() => store.getters['loggedIn']
        && store.getters['progressByUser'][STEPS.PAYMENT_METHOD] !== UNTOUCHED),
    isReadOnly: computed(() => false),
  });
};
